import { ProductType } from '../types';
import { useParams } from 'react-router-dom';
import { AccessProtectedPage } from './AccessProtectedPage';
import { useCallback } from 'react';
import FoundersNotes from './components/FoundersNotes';

export const FoundersNotesPage = () => {
  const { previewKey } = useParams();
  const render = useCallback(() => <FoundersNotes />, []);

  return (
    <AccessProtectedPage
      overrideCheck={previewKey != null}
      productType={ProductType.FOUNDERS_NOTES}
      renderContent={render}
    />
  );
};
